import { render, staticRenderFns } from "./AlertRSTable.vue?vue&type=template&id=0ce97465&scoped=true&"
import script from "./AlertRSTable.vue?vue&type=script&lang=js&"
export * from "./AlertRSTable.vue?vue&type=script&lang=js&"
import style0 from "./AlertRSTable.vue?vue&type=style&index=0&id=0ce97465&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce97465",
  null
  
)

export default component.exports